import * as axios from 'axios'

export default class Api {
  constructor() {
    this.api_token = null
    this.client = null
    this.api_url = process.env.REACT_APP_BASE_API_URL
  }

  init = () => {
    this.api_token = localStorage.getItem('apiToken')

    let headers = {
      Accept: 'application/json',
    }

    if (this.api_token) {
      headers.Authorization = `Bearer ${this.api_token}`
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
      // responseType: "blob",
    })

    return this.client
  }

  login(data) {
    return this.init().post('/auth/login-tesis', data)
  }

  loginBackdoor(data) {
    return this.init().post('/auth/admin-login-as-alumni', data)
  }

  changePassword(data) {
    return this.init().post('/change-password', data)
  }

  register(data) {
    return this.init().post('/auth/register-tesis', data)
  }

  getScientificField = (params) => {
    return this.init().get('/list/bidang-keilmuan', {params})
  }

  getThesis = (params) => {
    return this.init().get('/list/tesis', {params})
  }

  getThesisAdmin = (params) => {
    return this.init().get('/list/tesis/admin', {params})
  }

  getThesisDetail = (id) => {
    return this.init().get(`/detail/tesis/${id}`)
  }

  getTotalThesis = () => {
    return this.init().get(`/list/total-tesis`)
  }

  getLanguage = (params) => {
    return this.init().get(`/list/bahasa`, {params})
  }

  getThesisFeedback = (thesisId) => {
    return this.init().get(`/list/feedback/${thesisId}`)
  }

  forgotPassword = (data) => {
    return this.init().post('/auth/forgot-password', data)
  }

  storeThesisFeedback = (data) => {
    return this.init().post('/tesis/feedback', data)
  }

  registerThesis = (data) => {
    return this.init().post('/register-peneliti-tesis', data)
  }

  getTotalThesisPublic = () => {
    return this.init().get('/list/total-tesis-publik')
  }

  getTotalScolarship = () => {
    return this.init().get('/list/total/beasiswa')
  }

  getMasterTable = (params) => {
    return this.init().get('/list/master/table', {params})
  }

  getThesisFile = (id) => {
    return this.init().get(`/detail/tesis/enkrip/${id}`)
  }

  getProfile = () => {
    return this.init().get(`/profile/v2`)
  }

  getPrivacyPolicy = (data) => {
    return this.init().post(`/privacy-policy`, data, {
      timeout: 60000, // waktu timeout khusus, misalnya 60 detik (60000 ms)
    })
  }

  storePrivacyPolicy = (data) => {
    return this.init().post(`/privacy-policy/agree`, data)
  }

  getPublishDate = () => {
    return this.init().get(`/list/tesis/date/publish`)
  }

  getCountry = () => {
    return this.init().get(`/list/tesis/country/publish`)
  }

  getTemplateMitra = (type) => {
    return this.init().get(`/template-proposal/url-by-tipe/${type}`)
  }

  storeMasterTable = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/master/table`, formData)
  }

  updateMasterTable = (data, id) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/master/table/${id}`, formData)
  }

  changePeriodJob = (data, id) => {
    return this.init().post(`/company-job-change-expired/${id}`, data)
  }

  updateFotoProfile = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`user/user_detail/upload-image-tesis`, formData)
  }

  // PANA
  getTimeServer = () => {
    return this.init().get('/server-time')
  }

  getTemplateImport = () => {
    return this.init().get('/user/pana-user/assign-excel-template')
  }

  getAssessmentExport = () => {
    return this.init().get('/user/pana-user/assessment-excel')
  }

  importTemplateImport = (data) => {
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post('user/pana-user/assign-excel-upload', formData)
  }

  getPanaBatch = (params) => {
    return this.init().get('/pana/batch', {params})
  }

  addPanaBatch = (data) => {
    return this.init().post(`/pana/batch`, data)
  }

  updatePanaBatch = (data, id) => {
    return this.init().post(`/pana/batch/${id}`, data)
  }

  addMember = (data) => {
    return this.init().post(`/pana/tambah/anggota`, data)
  }

  getRegisterPana = () => {
    return this.init().get(`/pana/detail-pendaftaran`)
  }

  registerPana = (data) => {
    return this.init().post(`/pana/store`, data)
  }

  getListRegistrationPana = (params) => {
    return this.init().get(`/user/pana-user/list-pendaftaran-by-admin`, {params})
  }

  getDetailProposal = (id) => {
    return this.init().get(`/proposal-penilaian/${id}`)
  }

  saveAssessmentProposal = (data) => {
    return this.init().post(`/proposal-penilaian`, data)
  }

  getDetailInterview = (id) => {
    return this.init().get(`/wawancara-penilaian/${id}`)
  }

  saveAssessmentInterview = (data) => {
    return this.init().post(`/wawancara-penilaian`, data)
  }

  saveAssessmentVerificator = (data) => {
    return this.init().post(`/penilaian/verifikator`, data)
  }

  getProfileAwardee = (data) => {
    return this.init().post(`/profile-awardee-by-email`, data)
  }

  getDetailAssessment = (params) => {
    return this.init().get(`/master/proposal-aspek/get-all`, {params})
  }

  getInfoBox = (params) => {
    return this.init().get(`/aspek/tipe/get`, {params})
  }

  saveBaProposal = (data) => {
    return this.init().post(`/user/ba-proposal`, data)
  }

  saveBaInterview = (data) => {
    return this.init().post(`/user/ba-wawancara`, data)
  }

  getDetailLog = (idPana) => {
    return this.init().get(`/monitoring-superadmin/rangkuman-log/${idPana}`)
  }

  exportExcel = (param) => {
    return this.init().get(`/user/pana-user/export-excel-pendaftaran-by-admin`, param)
  }

  getPublisTimeStatus = (params) => {
    return this.init().get(`/monitoring-superadmin/waktu-publish/status`, {params})
  }

  // ALUMNI PROFILE ADMIN
  getAlumniProfile = (params) => {
    return this.init().get(`/admin/alumni-profiles`, {params})
  }

  getAlumniProfileAdmin = (params) => {
    return this.init().get(`/admin/alumni-profiles/admin-submissions`, {params})
  }

  getTotalCard = (params) => {
    return this.init().get(`/alumni-profile/dashboard-stats`, {params})
  }

  getMyAlumniSubmissions = (params) => {
    return this.init().get(`/alumni-profile/my-submissions`, {params})
  }

  getAlumniByNib = (data) => {
    return this.init().post(`/alumni-profile/get-by-nib`, data)
  }

  getDetailProfile = (id) => {
    return this.init().get(`/admin/alumni-profiles/${id}`)
  }

  getDetailProfilePublic = (id) => {
    return this.init().get(`/alumni-profile/view/${id}`)
  }

  approveProfile = (id) => {
    return this.init().post(`admin/alumni-profiles/${id}/approve`)
  }

  archiveProfile = (id) => {
    return this.init().post(`admin/alumni-profiles/${id}/archive`)
  }

  deleteProfile = (id) => {
    return this.init().delete(`admin/alumni-profiles/${id}`)
  }

  rejectProfile = (id, data) => {
    return this.init().post(`admin/alumni-profiles/${id}/reject`, data)
  }

  staredProfile = (id, data) => {
    return this.init().post(`admin/alumni-profiles/${id}/toggle-star`, data)
  }

  getProgramBeasesiwa = (params) => {
    return this.init().get(`alumni-profile/program-beasiswa`, {params})
  }

  getBidangSektor = (params) => {
    return this.init().get(`alumni-profile/bidang-sektor`, {params})
  }

  saveProfile = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/admin/alumni-profiles/add-manual`, formData)
  }

  editProfile = (id, data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/admin/alumni-profiles/${id}`, formData)
  }

  // PANA ADMIN
  getPublisTime = (params) => {
    return this.init().get(`/monitoring-superadmin/waktu-publish`, {params})
  }

  changePresention = (data) => {
    return this.init().post(`/monitoring-superadmin/change-presention`, data)
  }

  savePublishTime = (data) => {
    return this.init().post(`/monitoring-superadmin/waktu-publish`, data)
  }

  getMonitoring = (params) => {
    return this.init().get(`/monitoring-superadmin`, {params})
  }

  downloadAllFile = (panaId) => {
    return this.init().get(`/monitoring-superadmin/download-all-files-detail-proposal/${panaId}`)
  }

  getDetailAdminProposal = (registerId) => {
    return this.init().get(`/monitoring-superadmin/proposal-detail/${registerId}`)
  }

  getDetailAdminInterview = (registerId) => {
    return this.init().get(`/monitoring-superadmin/detail-wawancara/${registerId}`)
  }

  saveIntegrityFacts = (data) => {
    return this.init().post(`/pana/generate-pakta-integritas`, data)
  }

  getIntegrityFacts = () => {
    return this.init().get(`/pana/check-pakta-integritas`)
  }

  getLogChangeStatus = (params) => {
    return this.init().get(`/monitoring-superadmin/status-log`, {params})
  }

  getDetailAssessmentAdmin = (params) => {
    return this.init().get(`/master/proposal-aspek`, {params})
  }

  getDetailVerif = (id) => {
    return this.init().get(`/penilaian/verifikator/${id}`)
  }

  saveDetailAssessment = (data) => {
    return this.init().post(`/master/proposal-aspek`, data)
  }

  updateDetailAssessment = (data, id) => {
    return this.init().put(`/master/proposal-aspek/${id}`, data)
  }

  deleteDetailAssessment = (id) => {
    return this.init().delete(`/master/proposal-aspek/${id}`)
  }

  getUser = (params) => {
    return this.init().get(`/user/pana-user`, {params})
  }

  addUser = (data) => {
    return this.init().post(`/user/pana-user`, data)
  }

  updateUser = (data, idHash) => {
    return this.init().put(`/user/pana-user/${idHash}`, data)
  }

  getRole = (params) => {
    return this.init().get(`/master/pana-role`, {params})
  }

  addRole = (data) => {
    return this.init().post(`/master/pana-role`, data)
  }

  updateRole = (data, idHash) => {
    return this.init().put(`/master/role/${idHash}`, data)
  }

  updateStatusAssessment = (data) => {
    return this.init().post(`/monitoring-superadmin/update-status-penilaian`, data)
  }

  getModules = (params) => {
    return this.init().get(`/master/all-modules`, {params})
  }

  getRoleModule = (param) => {
    return this.init().get(`/master/role/${param}/auth-object-list`, {
      params: typeof param === 'object' ? param : {param},
    })
  }

  getRoleAll = (params) => {
    return this.init().get(`/master/pana-role-list-all`, {params})
  }

  uploadFile = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }

    return this.init().post(`/pana/tambah/file`, formData)
  }

  statementLetter = (data) => {
    return this.init().post(`pana/surat-pernyataan`, data)
  }

  uploadStatementLetter = (data) => {
    //create form data for uploading file
    let formData = new FormData()
    for (let key in data) {
      formData.append(key, data[key])
    }
    return this.init().post(`/pana/upload-surat-pernyataan`, formData)
  }

  deleteMember = (data) => {
    return this.init().post(`/pana/hapus/anggota`, data)
  }

  profileByEmail = (data) => {
    return this.init().post(`/pana/data-by-email`, data)
  }

  checkPana = (data) => {
    return this.init().get(`/pana/check`, data)
  }

  updateProfile = (data) => {
    return this.init().post(`/pana/pembaruan-profile`, data)
  }

  getThemeList = () => {
    return this.init().get(`/pana/list`)
  }

  getTemplateFile = () => {
    return this.init().get(`/template-proposal/list-with-urls`)
  }

  themeListByLocus = (data) => {
    return this.init().post(`/pana/tema-locus`, data)
  }

  checkTeams = () => {
    return this.init().get(`/pana/check-anggota`)
  }

  checkAgreementLetter = () => {
    return this.init().get(`/pana/check-surat-pernyataan`)
  }

  deletePana = (data) => {
    return this.init().post(`/pana/cancel`, data)
  }

  // PANA Laporan Kegiatan (Monev)
  getLaporanKegiatan = (params) => {
    return this.init().get('/pana-laporan-kegiatan', {params})
  }

  getMyLaporanGrouped = () => {
    return this.init().get('/pana-laporan-kegiatan/my-laporan-grouped')
  }

  getLaporanDetail = (id) => {
    return this.init().get(`/pana-laporan-kegiatan/${id}`)
  }

  createLaporanKegiatan = (data) => {
    let formData = new FormData()
    for (let key in data) {
      if (key === 'files' && Array.isArray(data[key])) {
        data[key].forEach((file) => {
          formData.append('files[]', file)
        })
      } else {
        formData.append(key, data[key])
      }
    }
    return this.init().post('/pana-laporan-kegiatan', formData)
  }

  updateLaporanKegiatan = (id, data) => {
    let formData = new FormData()
    for (let key in data) {
      if (key === 'files' && Array.isArray(data[key])) {
        data[key].forEach((file) => {
          formData.append('files[]', file)
        })
      } else {
        formData.append(key, data[key])
      }
    }
    return this.init().post(`/pana-laporan-kegiatan/${id}`, formData)
  }

  deleteLaporanKegiatan = (id) => {
    return this.init().delete(`/pana-laporan-kegiatan/${id}`)
  }

  addFilesToLaporan = (id, files) => {
    let formData = new FormData()
    files.forEach((file) => {
      formData.append('files[]', file)
    })
    return this.init().post(`/pana-laporan-kegiatan/${id}/files`, formData)
  }

  deleteFileFromLaporan = (laporanId, fileId) => {
    return this.init().delete(`/pana-laporan-kegiatan/${laporanId}/files/${fileId}`)
  }

  // Tema Essay API
  getTemaEssayList = (params) => {
    return this.init().get(`/tema-essay`, {params})
  }

  getTemaEssayDetail = (id) => {
    return this.init().get(`/tema-essay/${id}`)
  }
}
